import React from "react";
import * as R from "ramda";
import Scrollbar from "react-scrollbars-custom";
import ConversationPanel from "../components/conversation-panel/ConversationPanel";
import { GlobalStyle, ScrollDown, ScrollBarWrapper } from "./DbotAppStyles";
import { resolveButtons, resolveConversation } from "../business/ResolveConversationFunctions";
import { ButtonsPanel } from "../components/buttons-panel/ButtonsPanel";
import { clickButton, clickImage, clickInvestButton } from "../DbotActions";
import { dbotBlockApi } from "../business/Functions";
import { fetchBlock } from "../business/DbotHelperFunctions";

export const DbotAppLight = (props) => {
  const actions = dbotActions(props.dispatch);
  const scrollbar = props.useRef();
  const [scrollDownButton, setScrollDownButton] = props.useState(false);
  props.useEffect(() => {
    setScrollbarBehavior(scrollbar.current, props.buttonsDelay, setScrollDownButton);
  });
  let dbotComponents = (
    <>
      <ConversationPanel
        appMode={props.appMode}
        messages={resolveConversation(
          props.records,
          props.mediaUrl,
          getBlockApiF(props.apis),
          props.variables,
          !!props.mediaUrl,
          actions.logGifAB
        )}
        dispatch={props.dispatch}
        actions={actions}
        useState={props.useState}
        useEffect={props.useEffect}
      />
      {ButtonsPanel(
        resolveButtons(
          props.records,
          props.mediaUrl,
          actions,
          getBlockApiF(props.apis),
          props.variables,
          !!props.mediaUrl,
          actions.logGifAB
        ),
        props.buttonsDelay,
        props.appMode,
        props.useState
      )}
    </>
  );
  return wrapScrollbar(scrollbar, dbotComponents, scrollDownButton, setScrollDownButton);
};

const wrapScrollbar = (scrollbar, wrappedComponent, scrollDownBotton, setScrollDownButton) => (
  <ScrollBarWrapper>
    <Scrollbar
      onScrollStop={() => handleScroll(scrollbar.current.getScrollValues(), scrollDownBotton, setScrollDownButton)}
      noScrollX
      ref={scrollbar}
      style={{ width: "100%", height: "100%" }}
      momentum={true}
    >
      <GlobalStyle scrollBarColor={scrollDownBotton} />
      {wrappedComponent}
    </Scrollbar>
    <ScrollDown visible={scrollDownBotton} onClick={() => scrollbar.current.scrollToBottom()} />
  </ScrollBarWrapper>
);

const dbotActions = (dispatch) => ({
  clickButton: (button) => dispatch(clickButton({ button })),
  clickImage: (src) => dispatch(clickImage(src)),
  onClickInvestButton: (src, index) => dispatch(clickInvestButton(src, index)),
  logGifAB: (random) =>
    dispatch({ type: "LOG_GIF_AB", toLog: { elemId: random, eventName: "randomGifChat", category: "dbot" } }),
});

export const getBlockApiF = (apis) => (blockName) => {
  let preLoaded = R.find((a) => a.blockName === blockName, apis);
  return preLoaded ? preLoaded : dbotBlockApi(fetchBlock(blockName));
};

const handleScroll = (values, scrollDownButtonVisible, setScrollDownButton) => {
  const reachedBottom = isScrollBottom(values);
  if (!reachedBottom === scrollDownButtonVisible) return;
  setScrollDownButton(!reachedBottom);
};

const isScrollBottom = (scrollValues) => {
  const { scrollTop, scrollHeight, clientHeight } = scrollValues;
  const tolerance = 1;
  const position = (scrollTop + tolerance) / (scrollHeight - clientHeight);
  return position > 1;
};

const autoScrollBottom = (scrollbar) => {
  if (scrollbar === undefined || scrollbar === null) return;
  scrollbar.scrollToBottom();
};

const setScrollbarBehavior = (scrollbar, buttonsDelay, setScrollDownButton) => {
  let scrollValues = scrollbar.getScrollValues();
  if (scrollValues.scrollTop > 0) {
    if (!isScrollBottom(scrollValues)) {
      setScrollDownButton(true);
    }
  }
};
